import { revalidate as solidRevalidate } from '@solidjs/router';
import { LRUCache } from 'lru-cache';
import { isServer } from 'solid-js/web';

globalThis.__apiCache ??= isServer
	? null
	: new LRUCache({ max: 500, ttl: 1000 * 60 * 10, allowStale: false, updateAgeOnGet: true });

export const apiCache = () => globalThis.__apiCache;

type CacheablePath = string;

export async function revalidate(key?: CacheablePath | Array<CacheablePath> | true, force?: boolean) {
	const cache = apiCache();
	if (!cache) {
		await solidRevalidate(key === true ? undefined : key, force);
		return;
	}

	const cacheKeys = Array.from(cache.keys());
	if (key && key !== true) {
		const keys = Array.isArray(key) ? key : [key];
		for (const key of keys) {
			cacheKeys.filter((k) => k.startsWith(`${key}[`) || k === key).forEach((key) => cache.delete(key));
		}
	} else if (key === true) {
		cache.clear();
	}

	await solidRevalidate(key === true ? undefined : key, force);
}

declare global {
	var __apiCache: LRUCache<string, {}> | null;
}
